import { component as defineComponent } from 'flightjs'; // eslint-disable-line no-restricted-imports
import $ from 'jquery'; // eslint-disable-line no-restricted-imports

import dot from 'dot/doT';
import LikeButton from 'component_ui/like';
import LikeData from 'component_data/like';
import DetachedDropdown from '@99designs/common/jquery-plugins/detached-dropdown';
import DropdownRepositioner from 'component_ui/dropdown-repositioner';
import HtmlUpdater from 'component_ui/html-updater';

function DesignGrid() {
    this.defaultAttrs({
        grid: '[data-design-grid-grid]',
        template: '[data-design-grid-template]',
        'zero-state': '[data-design-grid-zero-state]',
        spinner: '[data-design-grid-spinner]',
        'zero-state-like-message': '[data-design-grid-zero-state-like-message]',
        clearAllFilters: '[data-design-grid-empty-clear-filters]',
        'open-mega-drawer-button': '[data-open-mega-drawer-button]',
    });

    this.after('initialize', function() {
        this.on(document, 'dataBrowseDesignsSuccess', this.buildDesigns);
        this.on(document, 'dataBrowseStarted', this.onFetchDesignsStart);
        this.on(document, 'dataBrowseEnd', this.onFetchDesignsEnd);
        this.on('click', {
            'open-mega-drawer-button': this.openMegaDrawerPanel,
            clearAllFilters: this.clearAllFilters,
        });
        $('body').on('click', '[data-login-signup-like-button]', () => {
            $(document).trigger('uiLikeButtonClicked');
        });
    });

    this.onFetchDesignsStart = function() {
        this.removeZeroState();
        this.select('grid').html('');
        this.select('spinner').removeAttr('data-hidden');
    };

    this.onFetchDesignsEnd = function() {
        this.select('spinner').attr('data-hidden', true);
    };

    this.buildDesigns = function(event, data) {
        const self = this;
        const designs = data.designs;
        this.removeZeroState();
        this.select('grid').html('');
        this.select('spinner').attr('data-hidden', true);
        if (designs.length > 0) {
            designs.forEach(el => {
                const design = self.buildDesign(el);
                self.select('grid').append(design);
            });
            this.attachLikeComponent();
            const dropdowns = this.attachDetachedDropdown();
            this.attachHtmlUpdater();
            this.attachDropdownRepositioner(dropdowns);
        } else {
            this.setZeroState(data.filterByLikesEnabled);
        }
    };

    this.attachLikeComponent = function() {
        const inspirationCollectorEnabled =
            window.inspirationCollector === 'enabled' && !window.isUserLoggedIn;

        LikeButton.attachTo(this.$node.find('[data-flight-like-button]'), {
            inspirationCollectorEnabled,
        });
        this.$node.find('[data-flight-like-button]').each(function() {
            LikeData.attachTo(this, {
                likeUrl: $(this).data('like-url'),
            });
        });
    };

    this.clearAllFilters = function() {
        this.trigger('uiRemoveAllFilters');
    };

    this.attachDetachedDropdown = function() {
        const dropdowns = DetachedDropdown.createAll(this.$node.find('[data-detached-dropdown]'));
        return dropdowns;
    };

    this.attachHtmlUpdater = function() {
        HtmlUpdater.attachTo('[data-login-signup-container]', {
            eventName: 'uiLikeButtonClicked',
            templateSelector: '[data-update-html-template="login-or-signup"]',
        });
    };

    this.attachDropdownRepositioner = function(dropdowns) {
        DropdownRepositioner.attachTo('[data-login-signup-like-button]', {
            eventName: 'uiLikeButtonClicked',
            dropdowns,
        });
    };

    this.buildDesign = function(el) {
        const template = dot.template(this.select('template').html());
        return template(el);
    };

    this.setZeroState = function(filterByLikesEnabled) {
        this.select('zero-state').removeAttr('data-hidden');
        if (filterByLikesEnabled) {
            this.select('zero-state-like-message').removeAttr('data-hidden');
        }
    };

    this.removeZeroState = function() {
        this.select('zero-state').attr('data-hidden', true);
        this.select('zero-state-like-message').attr('data-hidden', true);
    };

    this.openMegaDrawerPanel = function(event, data) {
        event.stopPropagation();
        const filterCategory = $(data.el).attr('data-open-mega-drawer-button-panel');
        $(document).trigger('uiMegaDrawerOpenPanel', { category: filterCategory });
    };
}

export default defineComponent(DesignGrid);



// WEBPACK FOOTER //
// ./src/js/component_ui/design-grid.js